import React from "react";
import { Container, Row, Col } from 'react-bootstrap';
// import Image from 'react-bootstrap/Image';

import { ServDesignTop } from "../assets/ServDesignData";
import { ServDesignTopImg } from "../assets/ServDesignData";
import { ServDesignTheory } from "../assets/ServDesignData";
import { ServDesignSensor } from "../assets/ServDesignData";
import { ServDesignCover } from "../assets/ServDesignData";
import { ServDesignFpc } from "../assets/ServDesignData";
import { ServDesignIntegrate } from "../assets/ServDesignData";
import { GoTopBtn } from '../components/GoTopBtn';
import './Services.css';

function ServiceDesign() {
  // console.log("get into function ServiceDesign()");
  return (
    <div className='services-page'>
      <header className='mt-1'>
        <Container className='d-flex align-items-center justify-content-center'>
          <h1 className='servdesign'>Service / Design</h1>
        </Container>
      </header>
      <section id='servdesigntop' className='servdesign-block bg-primary-subtle'>
        <h2 className='title-holder fs-1 text-primary'>Design</h2>
        <Container fluid>
          <Row className='d-flex justify-content-center'>
            { ServDesignTop.map(top => {
              return (
                <Col lg={12} key={top.id}>
                  <h2 className='m-4 text-center text-success'>{top.title}</h2>
                  <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{top.text}</p>
                  {/* <p className='m-2 fw-bold fs-4'>{top.text}</p> */}
                </Col>
              )
            })}
          </Row>
          <Row className='d-flex justify-content-around'>
            { ServDesignTopImg.map(topimg => {
              return (
                // <Col lg={4} key={topimg.id}>
                <Col lg={4} key={topimg.id} className='d-lg-flex'>
                  <img src={topimg.image} className='img-fluid' alt={topimg.alt} />
                  {/* <Image src={topimg.image} alt={topimg.alt} /> */}
                </Col>
              );
            })}
          </Row>
          {/* <Row className='image'> <Image src={topimg.image} alt={topimg.alt} /> </Row> */}
          <br />
        </Container>
      </section>

      <section id='servdesigntheory' className='servdesign-block bg-info-subtle'>
        <Container fluid className='my-1'> {
          <Row className='d-flex'>
            { ServDesignTheory.map(theory => {
              if (theory.image) {
                return (
                  <Row>
                    <h2 className='m-4 text-center text-primary bg-primary-subtle'>{theory.title}</h2>
                    {/* <h3 className='m-4 text-center text-primary'>{theory.subtitle}</h3> */}
                    <Col lg={6} key={theory.id}>
                      {/* <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre' }}>{theory.text}</p> */}
                      <img style={{ height: '50vh' }} src={theory.image} className='img-fluid' alt={theory.alt} />
                    </Col>
                    <Col lg={6} key={theory.id}>
                      <h2 className='m-4 text-center text-primary'>{theory.subtitle}</h2>
                      <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre' }}>{theory.text}</p>
                    </Col>
                  </Row>
                )
              }
              else {
                return (
                  <Row>
                    <h2 className='m-4 text-center text-primary bg-primary-subtle'>{theory.title}</h2>
                    <Col lg={12} key={theory.id}>
                      <h2 className='m-4 text-center text-primary'>{theory.title}</h2>
                      <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre' }}>{theory.text}</p>
                    </Col>
                  </Row>
                )
              }
            })}
          </Row>
        } </Container>
      </section>

      <section id='servdesignsensor' className='servdesign-block bg-primary-subtle'>
        <Container className='my-1'>
          <Row className='d-flex'> {
            ServDesignSensor.map(sensor => {
              return (
                <Col lg={12} key={sensor.id}>
                  <h2 className='m-4 text-center text-success'>{sensor.title}</h2>
                  <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre' }}>{sensor.text}</p>
                </Col>
              )
            })
          } </Row>
        </Container>
      </section>

      <section id='servdesigncover' className='servdesign-block bg-info-subtle'>
        <Container className='my-1'>
          <Row className='d-flex'> {
            ServDesignCover.map(cover => {
              return (
                <Col lg={12} key={cover.id}>
                  <h2 className='m-4 text-center text-primary'>{cover.title}</h2>
                  <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre' }}>{cover.text}</p>
                </Col>
              )
            })
          } </Row>
        </Container>
      </section>

      <section id='servdesignfpc' className='servdesign-block bg-primary-subtle'>
        <Container className='my-1'>
          <Row className='d-flex'> {
            ServDesignFpc.map(fpc => {
              return (
                <Col lg={12} key={fpc.id}>
                  <h2 className='m-4 text-center text-success'>{fpc.title}</h2>
                  <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre' }}>{fpc.text}</p>
                </Col>
              )
            })
          } </Row>
        </Container>
      </section>

      <section id='servdesignintegrate' className='servdesign-block bg-info-subtle'>
        <Container className='my-1'>
          <Row className='d-flex'> {
            ServDesignIntegrate.map(integrate => {
              return (
                <Col lg={12} key={integrate.id}>
                  <h2 className='m-4 text-center text-primary'>{integrate.title}</h2>
                  <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre' }}>{integrate.text}</p>
                </Col>
              )
            })
          } </Row>
        </Container>
      </section>
      <div> < GoTopBtn /> </div>
    </div>
  );
}

export default ServiceDesign;

// function ServiceDesign() {
//   return (
//     <div>
//       <h1 className='servdesign'>Design</h1>
//     </div>
//   );
// }

// export default ServiceDesign;

// const numbers = [1, 2, 3, 4];
// const filteredNumbers = numbers.map((num, index) => {
//   if (index < 3) { return num; }
// });
// console.log(filteredNumbers);
// // index goes from 0, so the filterNumbers are 1,2,3 and undefined.
// // filteredNumbers is [1, 2, 3, undefined]
// // numbers is still [1, 2, 3, 4]

// console.log(
//   [1, , 3].map((x, index) => {
//     console.log(`Visit ${index}`);
//     return x * 2;
//   }),
// );
// // Visit 0
// // Visit 2
// // [2, empty, 6]


